export default {
    props: {
        alerta: {required: true}
    }
}
